export const FOLDER_NAME = {
  FLOOR_MAP: 'floormap',
  EMPLOYEE_IMAGE: 'employee_image',
  ICON: 'icon',
};

export const BUCKET_NAME = {
  STATIC: 'static',
};
